module.exports = __webpack_public_path__ + "static/img/combinedValveTechnical.6b10be1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/combinedValveTechnical.png
// module id = 9QYT
// module chunks = 1